import React, { useState } from 'react';
import MUIDataTable from "mui-datatables";
import '../styles/table.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import Button from '@mui/material/Button';


import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMediaQuery, useTheme, Box } from '@mui/material';
import Loader from './Loader';

const MisTable = () => {
    const [showVoucher, setShowVoucher] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [voucherData, setVoucherData] = React.useState({
        voucherId: null,
        expenseType: "",
        subType: "",
        expenseDate: "2024-05-23T00:00:00",
        expenseAmount: null,
        attachment: null,
        attachmentPath: "",
        description: "",
        applyDate: "2024-05-03T00:00:00",
        fromPlace: "",
        toPlace: "",
        distance: 0,
        fromDate: "1900-01-01T00:00:00",
        toDate: "1900-01-01T00:00:00",
        userId: 0,
        userName: "",
        role: "",
        status: "",
        entryBy: "",
        donationType: "",
        donationFor: "",
        adminActionDate: "1900-01-01T00:00:00",
        adminRemark: "",
        accountantActionDate: "1900-01-01T00:00:00",
        accountantRemark: ""
    });

    const handleGetVoucherData = async (voucherId) => {
        const url = `http://172.1.10.61:92/api/Accounts/get_voucher_details_by_event_id/${voucherId}`;
        axios.get(url)
            .then((response) => {
                setVoucherData(response.data);
                setShowVoucher(true);
            })
            .catch((err) => {
                toast.error("Failed to Load Expense Voucher.");
            }).finally(setLoading(false));
    }

    const dummyData = [
        { DocumentName: "Coupon", Quantity: "45", Revenue: "1900", voucherId: 1 },
        { DocumentName: "Memo", Quantity: "60", Revenue: "1650", voucherId: 2 },
        // Add more dummy data as needed
    ];

    const TableData = dummyData.map((item, index) => ({
        ...item,
        sn: index + 1,
    }));

    const columns = [
        {
            name: "sn",
            label: "SN",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => <div style={{ textAlign: 'start' }}>{value}</div>
            }
        },
        {
            name: "DocumentName",
            label: "Document Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => <div style={{ textAlign: 'start' }}>{value}</div>
            }
        },
        {
            name: "Quantity",
            label: "Quantity",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => <div style={{ textAlign: 'start' }}>{value}</div>
            }
        },
        {
            name: "Revenue",
            label: "Revenue",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => <div style={{ textAlign: 'start' }}>{value}</div>
            }
        },

        {
            name: "voucherId",
            label: "Action",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => (
                    <Button variant="contained"
                        sx={{ backgroundColor: '#1976d2', color: 'white', height: 32, padding: '6px 16px', '&:hover': { backgroundColor: '#1565c0' } }}
                        onClick={() => { handleGetVoucherData(value); setShowVoucher(!showVoucher) }}>View</Button>
                )
            }
        }
    ];

    const options = {
        selectableRows: 'none',
        filterType: 'dropdown',
        elevation: 0,
        rowsPerPageOptions: [10, 15, 25, 50],
        responsive: "standard",
        tableBodyHeight: 'auto',
        tableBodyMaxHeight: 'auto'
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const getMuiTheme = () => createTheme({
        typography: {
            fontFamily: "Poppins",
        },
        palette: {
            background: {
                paper: "#ffffff",
                default: "#000000",
            },
            mode: 'light'
        },
        components: {
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        backgroundColor: '#ffffff', // Background color of the header
                        color: '#000000 !important', // Text color of the header
                        padding: "10px 4px",
                        borderBottom: "1px solid #ddd", // Horizontal divide
                        borderRight: "0px solid #ddd", // Vertical divide
                        textAlign: "center", // Center align text
                        '& .MuiTableSortLabel-root': {
                            color: '#000000 !important',
                            '&.MuiTableSortLabel-active': {
                                color: '#000000 !important'
                            },
                        },
                        '& .MuiTableSortLabel-icon': {
                            color: '#000000 !important'
                        },
                    },
                    body: {
                        padding: "7px 15px",
                        color: "#000000",
                        borderBottom: "0px solid #000000", // Horizontal divide
                        borderRight: "0px solid #000000" // Vertical divide
                    },
                    footer: {
                        padding: "7px 15px"
                    }
                }
            }
        }
    });

    return (
        <>
            {loading && <Loader />}
            {/* {showVoucher && <VoucherPopup1 data={voucherData} openPopup={true} />} */}
            <div className='py-5 min-h-screen flex justify-center items-center'>
                <Box width="100%">
                    <ThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            className="center-label" // Apply the center-label class to center-align header text
                            data={TableData}
                            columns={columns}
                            options={options}
                        />
                    </ThemeProvider>
                </Box>
            </div>
        </>
    )
}

export default MisTable;
